import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubAsPublicQueryKeys } from "../clubAsPublic";
import { clubQueryKeys } from "./clubQueryKeys";

export const useMutationClubUpdateCommunicationProperties = ({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      params: Parameters<
        ApiType["clubApi"]["updateCommunicationProperties"]
      >[1],
    ) => api.clubApi.updateCommunicationProperties(clubId, params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: clubQueryKeys.getCommunicationProperties(clubId),
      });
      await queryClient.invalidateQueries({
        queryKey: clubAsPublicQueryKeys.propertiesSettings(clubId),
      });
    },
  });
};
